<template>
  <section v-if="isGetRequestPending" class="edit-document">
    <p-loading />
  </section>
  <section v-else class="edit-document">
    <header>
      <h1>Edit Document</h1>
      <div class="action-wrapper">
        <p-button v-if="$hasPermission('templates')" color="secondary" @click="confirmDelete">Delete</p-button>
      </div>
    </header>
    <p-edit-document :is-request-pending="isUpdateRequestPending" :is-request-failed="isUpdateRequestFailed" :item="item" @submit="update" />
    <footer></footer>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import CreateOrEditDocument from './_CreateOrEdit';
import Loading from '@/components/common/Loading';
import Button from '@/components/common/Button';

export default {
  components: {
    'p-edit-document': CreateOrEditDocument,
    'p-loading': Loading,
    'p-button': Button
  },
  computed: {
    ...mapState({
      item: s => s.visio.item,
      isGetRequestPending: s => s.visio.isGetRequestPending,
      isUpdateRequestPending: s => s.visio.isUpdateRequestPending,
      isUpdateRequestFailed: s => s.visio.isUpdateRequestFailed
    })
  },
  watch: {
    '$route.params': {
      handler() {
        this.$store.dispatch('visio/getById', this.$route.params.id);
      },
      immediate: true
    }
  },
  methods: {
    async update(data) {
      try {
        await this.$store.dispatch('visio/update', { ...data, id: this.$route.params.id });

        this.$toast.success({
          title: 'Update completed',
          message: `Document was updated.`
        });
        this.$router.push({ path: `/documents/visio/` });
      } catch (e) {
        const { message } = JSON.parse(await e.response.text());
        this.$toast.error({
          title: 'Update failed',
          message: message || `Please, try again later or contact our development team.`
        });
      }
    },
    async confirmDelete() {
      const { id, name } = this.item;

      const confirmResult = await this.$confirm({
        title: 'Delete document?',
        message: `Are you sure you want to delete document '${name}'?\n\nThis action can't be undone.`,
        confirm: 'Delete'
      });

      if (!confirmResult) {
        return;
      }

      const lock = this.$lock();
      try {
        await this.$store.dispatch('visio/delete', id);

        this.$toast.success({
          title: 'Document deleted',
          message: `Document '${name}' (${id}) was successfully deleted.`
        });
        this.$router.push({ path: `/documents/visio/` });
      } catch (e) {
        this.$toast.error({
          title: 'Failed to delete document',
          message: `Please, try again later or contact our development team.`
        });
      } finally {
        lock.release();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-document {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-rows: minmax(0, max-content) minmax(0, 1fr);
  width: 100%;
  height: 100%;
  padding: 0 0.5rem 0 1rem;

  header {
    width: 100%;
    padding: 0.5rem 0.5rem 0 0;
    box-sizing: border-box;
    position: relative;
  }

  h1 {
    color: var(--theme-on-surface);
    font-size: 1.5rem;
    font-weight: 700;
  }

  .action-wrapper {
    position: absolute;
    right: 0rem;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
